import lambdaHandler from './lambdaHandler';
export default lambdaHandler();